<template>
  <footer class="footer">
    <p>&copy; {{ new Date().getFullYear() }} LBC Vue App. All rights reserved.</p>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
.footer {
  text-align: center;
  padding: 20px;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  color: #6c757d;
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>